import React from "react";

import AlertTriangle from "@uui/AlertTriangle";

import { Button, Typography, FormHelperText } from "@mui/material";

import { Column, Row } from "@rui/Stack";
import TooltipWrapper from "@rui/TooltipWrapper";

const MissingMemberAutocompleteOption = ({
  value,
  error,
  onSubmit,
  alreadySelected,
  loading,
  purchaseRequired,
}: {
  value: string;
  error: string | null;
  onSubmit: (email: string) => void;
  alreadySelected: boolean;
  loading: boolean;
  purchaseRequired: boolean;
}) => {
  const optionIsDisabled = alreadySelected;

  const getButtonText = () => {
    switch (true) {
      case alreadySelected:
        return "Email already added";
      case purchaseRequired:
        return "License required";
      default:
        return "Invite to Workspace";
    }
  };

  return (
    <Column direction="column">
      <Row
        variant="apart"
        sx={{
          height: "28px",
          width: "100%",
          bgcolor: optionIsDisabled ? "background.default" : "#fff",
          pointerEvents: optionIsDisabled ? "none" : undefined,
        }}
      >
        <Row variant="left">
          <Typography
            variant="bodyPrimaryReg"
            noWrap
            sx={{
              color: optionIsDisabled
                ? "shades.neutral.500"
                : "shades.neutral.800",
              pl: 1,
              maxWidth: "220px",
            }}
          >
            {value}
          </Typography>
        </Row>
        <TooltipWrapper
          show={purchaseRequired}
          title="All licenses are in use. Add additional licnses to invite people to your Workspace."
          placement="top"
          enterDelay={2000}
        >
          <Button
            onClick={() => onSubmit(value)}
            disabled={loading || optionIsDisabled || purchaseRequired}
            startIcon={
              purchaseRequired ? (
                <AlertTriangle sx={{ color: "warning.main" }} />
              ) : undefined
            }
          >
            <Typography
              variant="bodySecondaryReg"
              sx={{
                color: purchaseRequired
                  ? "warning.main"
                  : optionIsDisabled
                    ? "shades.neutral.500"
                    : "shades.primary.500",
                textDecoration:
                  optionIsDisabled || purchaseRequired ? "none" : "underline",
                fontWeight: optionIsDisabled ? 400 : 500,
              }}
            >
              {getButtonText()}
            </Typography>
          </Button>
        </TooltipWrapper>
      </Row>
      {error && (
        <FormHelperText error sx={{ pl: 1, mt: 1 }}>
          {error}
        </FormHelperText>
      )}
    </Column>
  );
};

export default MissingMemberAutocompleteOption;
